/**
 * Try to refresh session by retrieval of globalContext in hope that session still cached by redis
 */
import IService from '../IService';

export default IService.extend({
  _getUrl: function () {
    return app.apiUrl('/api/v1/translations');
  },

  /**
   * Resolved if user is authenticated
   * @return {deferred.promise}
   */
  translate: function (params) {
    const promise = new _.ColdPromise();
    $.ajax({
      url: this._getUrl(),
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(params),

      error: function (error) {
        console.error('Api error occured in translate.js: ', error);
        promise.reject(error);
      },

      success: function (response) {
        promise.resolve(response.translatedTextModels);
      },
    });

    return promise;
  },

  supportedLanguages: function () {
    const languages = [
      {
        language: 'nl',
        name: 'Dutch',
      },
      {
        language: 'en',
        name: 'English',
      },
      {
        language: 'fr',
        name: 'French',
      },
      {
        language: 'de',
        name: 'German',
      },
      {
        language: 'it',
        name: 'Italian',
      },
      {
        language: 'pt',
        name: 'Portuguese',
      },
      {
        language: 'es',
        name: 'Spanish',
      },
      {
        language: 'zh-CN',
        name: 'Chinese Simplified',
      },
      {
        language: 'zh-TW',
        name: 'Chinese Traditional',
      },
    ];

    return Promise.resolve(_.sortBy(languages, (l) => l.name));
  },
});
